<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="375px"
    :close-on-click-overlay="true"
    class="draw-dialog"
  >
    <div class="draw-container">
      <div class="draw-box">
        <img class="draw-title" src="@/assets/images/draw-title.png" alt="" />
        <img
          class="draw-second-title"
          src="@/assets/images/draw-second-title.png"
          alt=""
        />

        <div class="draw-main" v-if="!ruleShow">
          <div class="draw-num-and-rule">
            <span class="draw-number"
              >剩余抽奖数：{{ totalPrizeNum }}次
              <em v-if="totalPrizeNum > 0" class="draw-again" @click="drawReset"
                >再抽一次</em
              ></span
            >
            <div class="draw-rule" @click="ruleShow = true">
              <span>抽奖规则</span>
              <img src="@/assets/images/arrow.png" alt="" />
            </div>
          </div>
          <div class="draw-brand">
            <div
              v-for="(item, index) in flippedCards"
              :key="index"
              :class="{
                'draw-brand-item': true,
                flashing: clickIndex === index,
                flipped: item.flipped,
              }"
            >
              <div class="draw-front">
                <img
                  class="draw-front-item"
                  src="@/assets/images/draw-box1.png"
                  alt=""
                  @click="flipCard(item, index)"
                />
              </div>

              <div class="draw-back">
                <div
                  :class="[
                    'draw-back-item',
                    activeIndex != index ? 'unActived-item' : '',
                  ]"
                >
                  <img src="@/assets/images/get-point-icon.png" alt="" />
                  <span>积分</span>
                  <span>+{{ item.score }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="draw-num-and-rule">
            <span class="draw-number draw-point"
              >我的积分：{{ pointNumber }}</span
            >
            <div class="draw-rule" @click="goToGamePiont">
              <span>兑换转游积分</span>
              <img src="@/assets/images/arrow.png" alt="" />
            </div>
          </div>
        </div>

        <div class="draw-main" v-else>
          <div class="rule-title">
            <div class="rule-back" @click="ruleShow = false">
              <img src="@/assets/images/ic_right_four.png" alt="" />
              <span>返回</span>
            </div>
            <h1>抽取规则</h1>
          </div>

          <div class="rule-desc">
            <span>1、点击下方抽取即可翻牌赢取奖励，反派成功即为抽取成功；</span>
            <span
              >2、每一笔订单充值成功（实付≥2元），均可获得一次抽奖机会，积分数量与订单金额有关；
            </span>
            <span
              >3、翻牌可获取积分奖励，奖励分为三档，由小到大，概率分别为10%、40%、50%；
            </span>
            <span>4、积分可用户兑换首充优惠券；</span>
          </div>
        </div>
      </div>
      <img
        @click="dialogVisible = false"
        class="close"
        src="@/assets/images/coupon-model-close.png"
        alt=""
      />
    </div>
  </van-dialog>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    pointId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      clickIndex: null,
      activeIndex: 0,
      isFlipping: false,
      isFlashing: false,
      flippedCards: [],
      pointNumber: 0,
      totalPrizeNum: 0,
      drawScoreId: "",
      ruleShow: false,
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    this.getScoreInfo();
    this.getDrawScoreRecordList();
  },
  methods: {
    // 游戏重置
    drawReset() {
      this.clickIndex = null;
      this.getScoreInfo();
      this.getDrawScoreRecordList();
    },

    async flipCard(info, index) {
      if(this.totalPrizeNum == 0) {
        this.$toast('抽奖次数不足')
        return
      }
      this.drawScoreId = info.id;
      const { data } = await this.drawScore();
      this.clickIndex = index;
      this.activeIndex = index;
      this.flippedCards[index].flipped = false; // 确保其他卡片不翻转
      // 找到匹配的对象
      const matchIndex = this.flippedCards.findIndex(
        (item) => item.score === data.winScore
      );
      console.log(matchIndex, "matchIndex---");
      if (matchIndex !== -1) {
        // 交换 score 的值
        const tempScore = this.flippedCards[this.activeIndex].score;
        this.flippedCards[matchIndex].score = tempScore;
        this.flippedCards[this.activeIndex].score = data.winScore;
      }
      setTimeout(() => {
        info.flipped = true;
        this.clickIndex = null;
        // 1秒后翻转其他两张牌
        setTimeout(async () => {
          this.flippedCards.forEach((item, i) => {
            if (i !== index) {
              item.flipped = true; // 翻转其他牌
            }
          });

          this.getScoreInfo();
          try {
            const { totalCount } = await requestMethods(
              "/modules/drawscore/drawScoreRecord/getDrawScoreRecordList.htm",
              "post",
              {
                searchParams: JSON.stringify({
                  uuid: this.uuid,
                  appType: "WM",
                }),
                pageSize: 999,
                currentPage: 1,
              }
            );

            this.totalPrizeNum = totalCount;
            this.$emit('priseChange')
          } catch (error) {
            this.$toast({
              message: error.message,
              position: "bottom",
            });
          }
        }, 1000); // 1秒后翻转其他牌
      }, 600); // 闪烁时间
    },

    /**
     * 获取我的积分
     */
    async getScoreInfo() {
      try {
        const { data } = await requestMethods(
          "/modules/score/score/getScoreInfo.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
          }
        );
        this.pointNumber = data.score;
      } catch (err) {
        this.$toast(err.message);
      }
    },

    /**
     * 获取抽奖次数
     */
    async getDrawScoreRecordList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/drawscore/drawScoreRecord/getDrawScoreRecordList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              uuid: this.uuid,
              appType: "WM",
            }),
            pageSize: 999,
            currentPage: 1,
          }
        );

        if (totalCount == 0) {
          this.flippedCards = [
            {
              score: 1,
              id: 111,
              flipped: false,
            },
            {
              score: 2,
              id: 111,
              flipped: false,
            },
            {
              score: 3,
              id: 111,
              flipped: false,
            },
          ];
        } else {
          let info = data[totalCount - 1];
          this.flippedCards = [
            {
              score: info.leftScore,
              id: info.id,
              flipped: false,
            },
            {
              score: info.centerSocre,
              id: info.id,
              flipped: false,
            },
            {
              score: info.rightScore,
              id: info.id,
              flipped: false,
            },
          ];
        }
        this.totalPrizeNum = totalCount;
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 53. 抽奖获取积分
     */
    async drawScore() {
      try {
        const { data } = await requestMethods(
          "/modules/drawscore/drawScoreRecord/drawScore.htm",
          "post",
          {
            uuid: this.uuid,
            drawScoreId: this.drawScoreId,
          }
        );
        return {
          data: data,
        };
      } catch (err) {
        this.$toast(err.message);
      }
    },

    goToGamePiont() {
      this.$router.push({ path: "/gamePoints" });
    },
  },
};
</script>

<style lang="scss" scoped>
.draw-dialog,
.van-dialog__content {
  overflow: visible; /* 允许内容超出 */
}
.draw-container {
  // position: relative;
  .draw-title {
    position: absolute;
    width: 618px;
    height: 130px;
    top: -136px;
    left: 66px;
  }

  .draw-box {
    width: 540px;
    height: 580px;
    background: #ffffff;
    margin: 0 auto;
    border-radius: 24px;

    .draw-second-title {
      width: 540px;
      height: 130px;
      margin-top: -34px;
    }

    .draw-main {
      .draw-num-and-rule {
        text-align: center;
        margin-bottom: 26px;
        .draw-number {
          display: block;
          margin-top: 15px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #000000;
          line-height: 33px;
          margin-bottom: 17px;

          .draw-again {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
            line-height: 33px;
            text-align: left;
            font-style: normal;
            text-decoration-line: underline;
          }
        }
        .draw-point {
          font-weight: 600;
          font-size: 28px;
          color: #000000;
        }
        .draw-rule {
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #8f8f8f;
            line-height: 33px;
          }
          img {
            width: 11px;
            height: 19px;
            margin-left: 10px;
          }
        }
      }
      .draw-brand {
        height: 212px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        .draw-brand-item {
          width: 162px;
          height: 212px;
          perspective: 1000px; /* 添加透视效果 */
          position: relative;
          margin: 5px;
        }
      }
      .draw-front,
      .draw-back {
        width: 100%;
        height: 100%;
        position: absolute;
        backface-visibility: hidden; /* 隐藏背面内容 */
        transition: transform 0.6s;
        .draw-front-item {
          width: 162px;
          height: 212px;
          margin: 5px;
        }
      }
      .draw-front {
        z-index: 2;
      }
      .draw-back-item {
        width: 162px;
        height: 200px;
        margin: 5px;
        background: #ff8c4d;
        border-radius: 16px;
        text-align: center;

        img {
          width: 60px;
          height: 60px;
          margin-top: 40px;
        }
        span {
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 24px;
          color: #ffffff;
          line-height: 33px;
        }
      }
      .unActived-item {
        opacity: 0.3;
      }

      .draw-front {
        transition: transform 0.6s;
      }

      .draw-back {
        transform: rotateY(180deg);
      }

      .flipped .draw-front {
        transform: rotateY(180deg);
      }
      .flipped .draw-back {
        transform: rotateY(0); /* 背面显示 */
      }
      .flashing {
        animation: flash 0.3s ease infinite;
      }
      @keyframes flash {
        0%,
        100% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
      }

      .rule-title {
        display: flex;
        align-items: center;
        margin: 0 40px;

        .rule-back {
          display: flex;
          align-items: center;

          img {
            width: 11px;
            height: 19px;
            margin-right: 10px;
            transform: rotate(180deg);
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #8f8f8f;
            line-height: 33px;
          }
        }
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 28px;
          color: #000000;
          line-height: 40px;
          margin-left: 105px;
        }
      }
      .rule-desc {
        margin: 20px 40px;
        span {
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: rgba(0, 0, 0, 0.5);
          line-height: 33px;
          margin-top: 20px;
        }
      }
    }
  }

  .close {
    width: 60px;
    height: 136px;
    position: absolute;
    left: 345px;
    top: 580px;
  }
}
.van-dialog {
  background: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/DrawPrizeDialog.vue